<style scoped>
    .vs-table--tbody-table .tr-values td {
        padding-top: 5px;
        padding-bottom: 5px;
    }
</style>
<template>
    <div>
        <vs-card class="p-4 mb-0">
            <div slot="header" class="flex flex-wrap items-center justify-between">
                <div class="flex items-center">
                    <vs-button radius color="primary" icon="keyboard_backspace" @click="back
                    "></vs-button>
                    <h4 style="margin-left: 10px">FGR Details</h4>
                </div>
                <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="submitForm" icon="save">Receive</vs-button>
            </div>
            <div class="vx-row mt-5">
                <div class="vx-col lg:w-1/4 w-full">
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            ID*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" disabled/>
                        </div>
                    </div>
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            Reference*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="data.fgr_reference"/>
                        </div>
                    </div>
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            GR Date*
                        </div>
                        <div class="vx-col w-2/3">
                            <flat-pickr class="w-full" v-model="data.gr_date"/>
                        </div>
                    </div>
                </div>
                <div class="vx-col lg:w-1/4 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Status*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="data.status" disabled/>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Client ID*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="data.client.client_code" disabled/>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Warehouse ID*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="data.warehouse.warehouses_code" disabled/>
                        </div>
                    </div>
                </div>
                <div class="vx-col lg:w-1/4 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Production ID*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="data.id" disabled/>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            &nbsp;
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="data.reference" disabled/>
                        </div>
                    </div>
                </div>
            </div>
            <vs-tabs class="mt-5">
                <vs-tab label="Item Details" class="pt-base">
                    <vs-button class="mr-4" type="border" @click="addDetail()">Add</vs-button>
                    <vs-button type="border" :disabled="details_selected.length < 1">Remove</vs-button>
                    <vs-table hoverFlat :data="data.details" v-model="details_selected" class="mt-base" multiple>
                        <template slot="thead">
                            <vs-th style="min-width: 70px; width: 70px">Line ID</vs-th>
                            <vs-th style="min-width: 200px;">Product ID</vs-th>
                            <vs-th style="min-width: 200px;">Description</vs-th>
                            <vs-th style="min-width: 120px; width: 120px">Pack ID</vs-th>
                            <vs-th style="min-width: 120px; width: 120px">Batch</vs-th>
                            <vs-th style="min-width: 120px; width: 120px">Exp. Date</vs-th>
                            <vs-th style="min-width: 80px; width: 80px">Qty</vs-th>
                            <vs-th style="min-width: 120px; width: 120px">UoM</vs-th>
                            <vs-th style="min-width: 120px; width: 120px">Stock Type</vs-th>
                            <vs-th style="min-width: 80px; width: 80px">Base Qty</vs-th>
                            <vs-th style="min-width: 120px; width: 120px">Base UoM</vs-th>
                        </template>
                        <template slot-scope="{data}">
                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                                <vs-td>
                                    <vs-input class="w-full" :value="indextr + 1" :disabled="true"/>
                                </vs-td>
                                <vs-td>
                                    <vs-input class="w-full" v-model="tr.product.product_code" :disabled="true"/>
                                </vs-td>
                                <vs-td>
                                    <vs-input class="w-full" v-model="tr.product.description_1" :disabled="true"/>
                                </vs-td>
                                <vs-td>
                                    <vs-input class="w-full" v-model="tr.pack_id" disabled/>
                                </vs-td>
                                <vs-td>
                                    <vs-input class="w-full" v-model="tr.batch" disabled/>
                                </vs-td>
                                <vs-td>
                                    <flat-pickr class="w-full" v-model="tr.expired_date" disabled/>
                                </vs-td>
                                <vs-td>
                                    <vs-input class="w-full" v-model="tr.qty" @input="qtyChange(tr)" :disabled="!tr.product_id"/>
                                </vs-td>
                                <vs-td>
                                    <vs-select
                                        class="selectExample"
                                        v-model="tr.uom_id"
                                        width="100%"
                                        autocomplete
                                        :disabled="!tr.product_id"
                                        @change="qtyChange(tr)"
                                    >
                                        <vs-select-item v-for="(item, index) in tr.product.uoms" :key="index" :value="item.uom.id" :text="item.uom.name"/>
                                    </vs-select>
                                </vs-td>
                                <vs-td>
                                    <vs-select
                                        class="selectExample"
                                        v-model="tr.stock_type_id"
                                        width="100%"
                                        autocomplete
                                        :disabled="!tr.product_id"
                                    >
                                        <vs-select-item v-for="(item, index) in stock_type.data" :key="index" :value="item.id" :text="item.name"/>
                                    </vs-select>
                                </vs-td>
                                <vs-td>
                                    <vs-input class="w-full" v-model="tr.open_qty" disabled/>
                                </vs-td>
                                <vs-td>
                                    <vs-input class="w-full" v-model="tr.product.base_uom.uom.name" disabled/>
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </vs-tab>
            </vs-tabs>
        </vs-card>
    </div>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
    components: {
        flatPickr
    },
    data() {
        return {
            isLoading: false,
            data: {},
            details: [],
            details_selected: [],
            components: [],
            components_selected: [],
            client: {
                data: [],
                loading: false,
                endpoint: 'master/clients',
                objectKey: 'client_code'
            },
            warehouse: {
                data: [],
                loading: false,
                endpoint: 'master/warehouses',
                objectKey: 'warehouses_code'
            },
            stock_type: {
                data: [],
                loading: false,
                endpoint: 'master/stocktypes',
                objectKey: 'name'
            },
            products: []
        }
    },
    watch: {
        isLoading: function() {
            if(this.isLoading) {
                this.$vs.loading();
            }
            else {
                this.$vs.loading.close();
            }
        }
    },
    methods: {
        back() {
            this.$router.push({
                name: 'fg-receiving'
            });
        },
        fetchData() {
            this.isLoading = true;
            Promise.all([
                this.$http.post('master/clients'),
                this.$http.post('master/warehouses'),
                this.$http.post('master/stocktypes')
            ])
            .then(this.$http.spread((clients, warehouses, stock_types) => {
                this.client.data = clients.data.data;
                this.warehouse.data = warehouses.data.data;
                this.stock_type.data = stock_types.data.data;
                this.isLoading = false;
            }))
            .catch(error => this.handleError(error));
        },
        productChange(data) {
            const product = this.products[this.products.findIndex(p => p.id == data.product_id)];
            
            if(product) {
                data.description = product.description_1;
                data.uoms = product.uoms;
                data.base_uom = product.base_uom.uom.name;
                data.uom_id = product.base_uom.uom.id;
            }
        },
        qtyChange(tr) {
            const uom = tr.product.uoms[tr.product.uoms.findIndex(d => d.uom_id == tr.uom_id)];

            if(uom) {
                tr.base_qty = (tr.qty / uom.denominator) * uom.numerator;
            }
        },
        submitForm() {
            const data = {
                reference: this.data.fgr_reference,
                gr_date: this.data.gr_date,
                vas_id: this.data.id,
                sreference: this.data.reference,
                sclient_id: this.data.client_id,
                details: this.data.details.map(item => {
                    return {
                        id: item.id,
                        qty: item.qty,
                        uom_id: item.uom_id
                    }
                })
            }

            this.isLoading = true;

            this.$http.post('valueaddedservice/fgreceiving/receive', data)
            .then(res => {
                this.$vs.notify({
                    color: 'success',
                    title: 'Success',
                    iconPack: 'feather',
                    icon:'icon-check',
                    text: 'Saved successfully'
                });
                
                this.$router.push({
                    name: 'fg-receiving-view',
                    params: {
                        id: res.data.id
                    }
                });

                this.isLoading = false;
            })
            .catch(error => this.handleError(error));
        }
    },
    mounted() {
        if(!this.$route.params.data) {
            this.$router.push({
                name: 'fg-receiving-add',
                params: {
                    data: res.data
                }
            });
        }
        else {
            this.data = this.$route.params.data;

            this.$http.post('master/stocktypes')
            .then(res => {
                this.stock_type.data = res.data.data;
                this.$vs.loading.close();
            })
            .catch(error => this.handleError(error));
        }
    }
};
</script>